// ---------- confettis et bulles ----------
// Purement décoratif : rien ici ne touche à l'état du jeu. Coupé entièrement quand le système
// demande moins d'animations.

import { settings } from './prefs';

/** Pas d'animation : le système le demande, ou le joueur l'a coupée dans les Réglages. */
export const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
const still = (): boolean => !settings().motion;

const COLORS = ['#ffd23f', '#ff6fae', '#3fd27a', '#67b8ff', '#ff9a1f', '#a77bff', '#ffffff'];

interface Part {
  x: number;
  y: number;
  vx: number;
  vy: number;
  r: number;
  vr: number;
  w: number;
  h: number;
  c: string;
  life: number;
  star: boolean;
}

let canvas: HTMLCanvasElement;
let ctx: CanvasRenderingContext2D;
let parts: Part[] = [];
let running = false;
let last = 0;

function size(): void {
  const d = devicePixelRatio || 1;
  canvas.width = innerWidth * d;
  canvas.height = innerHeight * d;
  ctx.setTransform(d, 0, 0, d, 0, 0);
}

export function initFx(el: HTMLCanvasElement, bubbles: HTMLElement): void {
  canvas = el;
  ctx = el.getContext('2d')!;
  size();
  addEventListener('resize', size);
  if (reduced) return;
  let h = '';
  for (let i = 0; i < 14; i++) {
    const s = 30 + Math.random() * 120;
    h += `<i style="width:${s}px;height:${s}px;left:${Math.random() * 100}%;top:${100 + Math.random() * 30}%;animation-duration:${18 + Math.random() * 26}s;animation-delay:-${Math.random() * 40}s"></i>`;
  }
  bubbles.innerHTML = h;
}

/** Une gerbe de confettis depuis (x, y), en coordonnées de la fenêtre. */
export function burst(x: number, y: number, n = 40, power = 1): void {
  if (still()) return;
  for (let i = 0; i < n; i++) {
    const a = Math.random() * Math.PI * 2;
    const v = (2 + Math.random() * 5) * power;
    parts.push({
      x,
      y,
      vx: Math.cos(a) * v,
      vy: Math.sin(a) * v - 3 * power,
      r: Math.random() * 6,
      vr: (Math.random() - 0.5) * 0.4,
      w: 6 + Math.random() * 6,
      h: 4 + Math.random() * 5,
      c: COLORS[(Math.random() * COLORS.length) | 0],
      life: 1,
      star: Math.random() < 0.25,
    });
  }
  if (!running) {
    running = true;
    last = performance.now();
    requestAnimationFrame(tick);
  }
}

/** La pluie de fin de grille : six gerbes échelonnées sur le haut de l'écran. */
export function rain(): void {
  for (let i = 0; i < 6; i++)
    setTimeout(
      () =>
        burst(
          innerWidth * (0.15 + Math.random() * 0.7),
          innerHeight * (0.15 + Math.random() * 0.3),
          45,
          1.3,
        ),
      i * 160,
    );
}

function tick(t: number): void {
  // Pas de temps borné : un onglet revenu au premier plan ne doit pas téléporter les confettis.
  const dt = Math.min(2.5, (t - last) / 16.7);
  last = t;
  ctx.clearRect(0, 0, innerWidth, innerHeight);
  parts = parts.filter((p) => p.life > 0 && p.y < innerHeight + 40);
  for (const p of parts) {
    p.vy += 0.22 * dt;
    p.vx *= 0.985;
    p.x += p.vx * dt;
    p.y += p.vy * dt;
    p.r += p.vr * dt;
    p.life -= 0.009 * dt;
    ctx.save();
    ctx.globalAlpha = Math.max(0, Math.min(1, p.life * 1.6));
    ctx.translate(p.x, p.y);
    ctx.rotate(p.r);
    ctx.fillStyle = p.c;
    if (p.star) {
      ctx.beginPath();
      for (let i = 0; i < 10; i++) {
        const rr = i % 2 ? 3 : 7,
          a = (i * Math.PI) / 5;
        ctx.lineTo(Math.cos(a) * rr, Math.sin(a) * rr);
      }
      ctx.fill();
    } else ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
    ctx.restore();
  }
  if (parts.length) requestAnimationFrame(tick);
  else {
    running = false;
    ctx.clearRect(0, 0, innerWidth, innerHeight);
  }
}

/** Le nombre de confettis en vol — pour les vérifications automatiques. */
export const flying = (): number => parts.length;
